import { render, staticRenderFns } from "./Popup1.vue?vue&type=template&id=122ba536&scoped=true&"
import script from "./Popup1.vue?vue&type=script&lang=js&"
export * from "./Popup1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122ba536",
  null
  
)

export default component.exports